export default __webpack_public_path__ + "static/media/result1.7d5ac914.png";